module.exports = __webpack_public_path__ + "static/josh-63beb5871a1e05803723c0a769ac56ea.jpg";